export default "__VITE_ASSET__XNXSrvxP__"